module.exports = __webpack_public_path__ + "media/src/img/help-flowers-0c953a23b8a52b494e5c7cf5bbe0b096.svg";